import { Button } from "@/components/ui/button";
import { Download, ArrowRight } from "lucide-react";
import TryOnlineButton from "@/components/landing/TryOnlineButton";
import MiniTimer from "@/components/landing/MiniTimer";

export default function CTASection({ downloadLink }) {
  const scrollToRegister = () => {
    document.getElementById("lead-capture")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="cta-section" className="py-14 md:py-24 bg-green-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-white rounded-full translate-x-1/4 translate-y-1/4" />
      </div>
      <div className="relative container mx-auto px-4 md:px-6 max-w-5xl text-center">
        <h2
          data-testid="cta-headline"
          className="text-3xl md:text-4xl font-bold text-white"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Start Saving Time in Your School Work Today
        </h2>
        <p className="mt-4 text-green-100 text-sm md:text-base max-w-xl mx-auto">
          Join thousands of teachers who have simplified their daily school tasks.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            data-testid="cta-register-btn"
            onClick={scrollToRegister}
            className="w-full sm:w-auto h-12 px-8 bg-white text-green-700 hover:bg-green-50 rounded-full text-base font-semibold shadow-lg"
          >
            Create Free Account
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
          <Button
            data-testid="cta-download-btn"
            asChild
            variant="outline"
            className="w-full sm:w-auto h-12 px-8 border-2 border-white text-white hover:bg-white/10 rounded-full text-base font-semibold"
          >
            <a href={downloadLink} target="_blank" rel="noopener noreferrer">
              <Download className="mr-2 w-4 h-4" />
              Download Teacher Utility Toolkit
            </a>
          </Button>
        </div>
        <div className="mt-4 flex justify-center">
          <TryOnlineButton variant="dark" />
        </div>
        <div className="mt-2 flex justify-center">
          <MiniTimer variant="light" />
        </div>
        <p className="mt-1.5 text-yellow-200 text-xs font-semibold">
          Download ଦରକାର ନାହିଁ — ସିଧା Browser ରେ ସବୁ Tools ଚଲାନ୍ତୁ!
        </p>
      </div>
    </section>
  );
}
